<div class="rush-header">
  <div class="logo-container">
    <img src="assets/images/logo-v3.png" />
  </div>
  <app-rush-profile></app-rush-profile>
</div>
